import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuetify from 'vuetify'
import './fonts.css'
import 'material-design-icons/iconfont/material-icons.css'
import './stylus/main.styl'
import 'please-wait/build/please-wait.css'
import 'spinkit/css/spinners/6-chasing-dots.css';

import App from './App'

import Theme from './Theme'

import VueGtag from 'vue-gtag'

Vue.use(Vuetify, {
  theme: Theme
})

Vue.use(VueGtag, {
  config: {
    id: 'G-QB79RSC2K1'
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js